export default __webpack_public_path__ + "static/media/2.cbd5b1ed.jpg";